import "slick-carousel"

export default () => {

	let sliderSmiles = $('.smiles-slides');

	if (sliderSmiles.length >= 1) {
		sliderSmiles.slick({
			infinite: true,
			arrows: true,
			dots: false,
			rows: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			pauseOnHover: false,
			pauseOnFocus: false,
			autoplaySpeed: 3000,
			centerMode: true,
			centerPadding: '315px',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						centerPadding: '200px',
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 992,
					settings: {
						centerPadding: '150px',
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 768,
					settings: {
						centerPadding: '80px',
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 520,
					settings: {
						centerPadding: '60px',
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 420,
					settings: {
						centerPadding: '30px',
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 380,
					settings: {
						centerMode: false,
						slidesToShow: 1,
					},
				},
			],
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/_smiles-slider.js